<div class="choose-topology-item-container">
    <div class="topology-container"
         [contextMenu]="callsMapMenu"
         [contextMenuSubject]="contextMenuData">
        <div class="normalization-source" *ngIf="selectionConfigurations.withOffline">
            <mat-checkbox name="isEquallyBalanced" color="primary" class="dest-type-request-uri"
                          [(ngModel)]="selectionConfigurations.isCombinedViewDisplayed"
                          (change)="isCombinedViewDisplayedChanged()">
                Include offline items
            </mat-checkbox>
        </div>
        <context-menu #callsMapMenu [menuClass]="!contextMenuData || contextMenuData.length === 0 ? 'hide-menu' : ''">
            <ng-template *ngFor="let action of contextMenuData"
                         contextMenuItem
                         (execute)="action.click()"
                         [visible]="action.visible"
                         [divider]="action.divider">
                <span [innerHtml]="action.html"></span>
            </ng-template>
        </context-menu>
        <network-diagram *ngIf="showNetworkDiagram"
                         [diagramId]="diagramId"
                         class="network-diagram-wrapper"
                         [initialDiagramOptions]="savedMapConfigurations"
                         [getClusteredEdgePropertiesByEdges]="getClusteredEdgePropertiesByEdges"
                         [getClusteredNodePropertiesByNodes]="getClusteredNodePropertiesByNodes"
                         (onDiagramReady)="onDiagramReady($event.diagramApi)"
                         (onContextMenu)="onContextMenu($event)"
                         (onSelect)="onSelect($event)">
        </network-diagram>
    </div>
    <div class="topology-actions">
        <mat-icon color="primary" class="topology-action" (click)="bringIntoView()">filter_center_focus</mat-icon>
        <mat-icon color="primary" class="topology-action" (click)="zoomIn()">zoom_in</mat-icon>
        <mat-icon color="primary" class="topology-action" (click)="zoomOut()">zoom_out</mat-icon>
    </div>
</div>
